import { render, staticRenderFns } from "./ModalSalaryRecord.vue?vue&type=template&id=e28fe900&"
import script from "./ModalSalaryRecord.vue?vue&type=script&lang=js&"
export * from "./ModalSalaryRecord.vue?vue&type=script&lang=js&"
import style0 from "./ModalSalaryRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports